var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoyasar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 429.63 413.97",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "moyasar-title"
  }, "Moyasar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "moyasar-title"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#191502",
    d: "M64.71 2.7c38.7-9.73 77.4 7.36 96.27 42.53l37.11 69.15-32.97 61.43-55.33-103.11c-9.4-17.52-26.04-14.88-30.92-13.66-4.88 1.23-20.78 6.77-20.78 26.65v242.57c0 19.88 15.91 25.43 20.78 26.65 4.88 1.24 21.52 3.86 30.92-13.66L268.64 45.23c18.87-35.17 57.57-52.26 96.27-42.53 38.71 9.73 64.71 43.08 64.71 82.99v242.57c0 39.91-26.01 73.27-64.72 82.99-7.24 1.82-14.48 2.7-21.59 2.7-30.89 0-59.33-16.64-74.67-45.23l-37.42-69.74 32.97-61.43 55.65 103.7c9.4 17.52 26.05 14.89 30.92 13.66 4.88-1.23 20.78-6.77 20.78-26.65V85.7c0-19.88-15.91-25.43-20.78-26.65-1.52-.38-4.2-.9-7.44-.9-7.13 0-17.01 2.52-23.48 14.56L160.98 368.74c-15.34 28.59-43.78 45.23-74.67 45.23-7.11 0-14.35-.88-21.59-2.7C26.01 401.54 0 368.18 0 328.27V85.7C0 45.79 26.01 12.43 64.71 2.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoyasar);
export default __webpack_public_path__ + "static/media/moyasar.c7b57014c98355ac5ed60d42e9d334e6.svg";
export { ForwardRef as ReactComponent };